import { Plugin, PluginKey } from 'prosemirror-state';
import plainSchema from '@prosemirror/schema/plainSchema';

export const pluginKey = new PluginKey('maxContentSizePlugin');

/**
 * Creates a plugin that restricts text input for the ProseMirrorinput
 */
export const createMaxContentSizePlugin = (maxContentSize) => {
  if (!maxContentSize) {
    return null;
  }

  return new Plugin({
    key: pluginKey,
    appendTransaction(transactions, oldState, newState) {
      const overMax = newState.doc && newState.doc.textContent.length > maxContentSize;

      const tr = newState.tr;

      if (overMax) {
        // The "to" range is text max character limitation minus 2
        // because the nodeSize includes the wrapper node (div) which is 2 characters
        tr.deleteRange(maxContentSize, newState.doc.nodeSize - 2);
      }

      tr.setMeta(pluginKey, { overMax });

      return tr;
    },
    state: {
      init(config, editorState) {
        if (editorState.schema !== plainSchema) {
          throw new Error('The maxContentSizePlugin currently only works with the plainSchema.');
        }

        return {
          overMax: undefined,
        };
      },
      apply(transaction, value) {
        const meta = transaction.getMeta(pluginKey);

        if (meta) {
          return {
            overMax: meta.overMax,
          };
        }

        return value;
      },
    },
  });
};

export default createMaxContentSizePlugin;
